// Lazily loaded screens. The feed ships in the main bundle; the rest (the inbox too) load on
// demand and are warmed on idle after sign-in so opening them still feels instant.
export const loadInbox = () => import("@web/inbox/InboxPage");
export const loadCompose = () => import("@web/compose/ComposeSheet");
export const loadMailFrame = () => import("@web/thread/MailFrame");
export const loadThread = () => import("@web/thread/ThreadPage");
export const loadAccounts = () => import("@web/accounts/AccountsPage");
export const loadSettings = () => import("@web/settings/SettingsPage");
export const loadLogin = () => import("@web/auth/LoginPage");
export const loadSetup = () => import("@web/auth/SetupPage");
export const loadCard = () => import("@web/feed/CardPage");
export const loadFocus = () => import("@web/focus/FocusPage");
export const loadPrompts = () => import("@web/workspace/PromptsPage");
export const loadLearning = () => import("@web/workspace/LearningPage");
export const loadWork = () => import("@web/work/WorkPage");
export const loadAudit = () => import("@web/audit/AuditPage");
export const loadHidden = () => import("@web/hidden/HiddenPage");
export const loadRecent = () => import("@web/recent/RecentPage");
export const loadFreshStart = () => import("@web/recent/FreshStartPage");
export const loadTasks = () => import("@web/tasks/TasksPage");
export const loadBrief = () => import("@web/notify/BriefPage");
export const loadScreener = () => import("@web/screener/ScreenerPage");
export const loadSpend = () => import("@web/settings/SpendPage");
export const loadMeasure = () => import("@web/settings/MeasurePage");
export const loadVips = () => import("@web/settings/VipsPage");
export const loadNotificationSettings = () => import("@web/settings/NotificationsPage");
export const loadCalendarSettings = () => import("@web/settings/CalendarPage");
export const loadDrafts = () => import("@web/compose/DraftsPage");
export const loadAnswers = () => import("@web/answers/AnswersPage");
export const loadAsk = () => import("@web/ask/AskPage");
export const loadWelcome = () => import("@web/setup/WelcomePage");
export const loadVoice = () => import("@web/settings/VoicePage");

export function preloadScreens(): void {
  const warm = () => {
    void loadInbox();
    void loadMailFrame();
    void loadCard();
    void loadFocus();
    void loadThread();
    void loadWork();
    void loadPrompts();
    void loadLearning();
    void loadHidden();
    void loadRecent();
    void loadTasks();
    void loadBrief();
    void loadAudit();
    void loadAccounts();
    void loadSettings();
    void loadScreener();
    void loadDrafts();
    void loadAnswers();
    void loadAsk();
    void loadVoice();
  };
  if (typeof requestIdleCallback === "function") requestIdleCallback(warm, { timeout: 3000 });
  else setTimeout(warm, 1500);
}
